module.exports = __webpack_public_path__ + "img/globe-no-svgrepo-com.d865bbf9.svg";